import React from 'react';

import { Tooltip } from '@/design-system';

export const DisabledTooltip: React.FC<
  React.PropsWithChildren<{
    disabled: boolean;
    disabledMsg: string | React.ReactNode;
  }>
> = (props) => {
  if (props.disabled && props.children) {
    return (
      <Tooltip title={props.disabledMsg}>
        <div>{props.children}</div>
      </Tooltip>
    );
  }
  return props.children;
};
